import {
  ContentLiveStateType,
  StreamStatusType,
} from "@/types/graphql/partner.generated";

export type StreamListBadge = "LIVE" | "SIGNAL" | "CANCELLED";

/** Ключи подписей чипа (статические, см. i18n-правила partner-кабинета). */
export const STREAM_LIST_BADGE_LABEL_KEYS: Record<StreamListBadge, string> = {
  LIVE: "streams.status.STARTED",
  SIGNAL: "streams.item.signalBadge",
  CANCELLED: "streams.status.CANCELLED",
};

export const STREAM_LIST_BADGE_COLORS: Record<
  StreamListBadge,
  "error" | "warning" | "default"
> = {
  LIVE: "error",
  SIGNAL: "warning",
  CANCELLED: "default",
};

/**
 * Чип на превью в списке стримов: LIVE у идущего эфира, SIGNAL у эфира,
 * который ещё не начат, но энкодер уже шлёт сигнал. Статус стрима остаётся
 * запасным признаком LIVE: его обновляет подписка, liveState догоняет.
 * CANCELLED у эфира отменённого события (отмена PPV).
 */
export function getStreamListBadge(item: {
  liveState?: ContentLiveStateType | null;
  stream?: { status: StreamStatusType } | null;
}): StreamListBadge | null {
  if (item.stream?.status === StreamStatusType.CancelledType) {
    return "CANCELLED";
  }
  if (
    item.liveState === ContentLiveStateType.LiveType ||
    item.stream?.status === StreamStatusType.StartedType
  ) {
    return "LIVE";
  }
  if (item.liveState === ContentLiveStateType.SignalType) return "SIGNAL";
  return null;
}
